import Service from '../Service';
import {SERVER_URL} from "../../utils/Constants";
import GeneralUtils from "../../utils/GeneralUtils";

export default class LogService extends Service {

    create(data) {
        return fetch(SERVER_URL + this.baseURL, {
            crossDomain: true,
            method: 'post',
            headers: {'Content-Type': 'application/json', Authorization: localStorage.getItem("Authorization")},
            body: JSON.stringify(GeneralUtils.addCreateInfo(data))
        }).then(response => {
            return response.json();
        }).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    createMany(dataList) {
        return fetch(SERVER_URL + this.baseURL + "/createMany", {
            crossDomain: true,
            method: 'post',
            headers: {'Content-Type': 'application/json', Authorization: localStorage.getItem("Authorization")},
            body: JSON.stringify(GeneralUtils.addCreateInfo(dataList))
        }).then(response => {
            return response.json();
        }).catch(error => {
            GeneralUtils.notification(error);
        });
    }
}